import * as React from "react"
import {graphql, Link, useStaticQuery} from "gatsby"
import {StaticImage} from "gatsby-plugin-image"
import {useEffect, useState} from 'react';
import {ReactSession} from "react-client-session";
import {navigate} from "gatsby"
import {ParallaxProvider} from 'react-scroll-parallax';
import {Trans, useI18next} from "gatsby-plugin-react-i18next";
import Menu from "../images/inline/menu.inline.svg"
interface Props {
    children?: any,
    footer?: boolean,
    footerTop?: boolean,
}

const Layout = ({children, footer = true, footerTop = true}: Props) => {
    let isVerified = false
    const [offset, setOffset] = useState(0)
    let navOffset = 500
    if (typeof window !== "undefined") {
        ReactSession.setStoreType("sessionStorage");
        isVerified = ReactSession.get("userVerified");
    }

    useEffect(() => {
        if (!isVerified) {
            let navigateTo = navigate('/welcome');
        }
        if (typeof window !== `undefined`) {
            window.onscroll = () => {
                setOffset(window.pageYOffset)
            }
        }
    }, [])

    const {languages, changeLanguage, language} = useI18next();
    const menuItems = [
        {
            name: language == 'es' ? 'Nuestra Esencia' : 'Our essence',
            url: '/our-essence',
            children: [
                {
                    name: language == 'es' ? 'Nuestro ADN' : 'Our DNA',
                    url: '/our-essence#our-essence'
                },
                {
                    name: language == 'es' ? 'Lo que nos hace diferentes' : 'What make us different',
                    url: '/our-essence#different'
                },
                {
                    name: language == 'es' ? 'Preservando la artesanía del tequila' : 'Preserving the Tequila craft',
                    url: '/#preservingTequila'
                },
                {
                    name: language == 'es' ? 'Proceso' : 'process',
                    url: '/tequilas/tequila-blanco#processTequila'
                }
            ],
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_1.jpg'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_1.jpg'} alt={'Tequila'}/>
            ],
        },
        // Dentro del listado de Notion "Ronda #2 Soporte" solicitaron desaparecer la sección "Where to buy"
        // Para el futuro que deseen activar esta sección, indicar exactamente que imagen quieren en lugar del señor a caballo.
        /*{
            name: language == 'es' ? 'Dónde Comprar' : 'WHERE TO BUY',
            url: '/buy',
            children: null,
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_2.jpg'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_2.jpg'} alt={'Tequila'}/>
            ],
        },*/
        {
            name: language == 'es' ? 'Nuestro Tequila' : 'Our Tequila',
            url: '/our-tequila',
            children: [
                {
                    name: 'Santaleza Blanco',
                    url: '/tequilas/tequila-blanco'
                },
                {
                    name: 'Santaleza Reposado',
                    url: '/tequilas/tequila-reposado'
                },
                {
                    name: 'Santaleza Añejo',
                    url: '/tequilas/tequila-anejo'
                },
                {
                    name: 'Santaleza Extra Añejo',
                    url: '/tequilas/tequila-extra-anejo'
                }
            ],
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_3.jpg'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_3.jpg'} alt={'Tequila'}/>
            ],
        },
        {
            name: language == 'es' ? 'Nuestro Tequila' : 'Our agave spirits',
            url: '/our-agave-spirits',
            children: [
                {
                    name: 'Santaleza las Reservas',
                    url: '/tequilas/santaleza-las-reservas'
                }
            ],
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_6.webp'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_06.webp'} alt={'Tequila'}/>
            ],
        },
        {
            name: 'Cocktails',
            url: '/cocktails',
            children: null,
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_4.webp'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_4.webp'} alt={'Tequila'}/>
            ],
        },
        {
            name: language == 'es' ? 'Contacto' : 'Contact Us',
            url: '/contact',
            children: [
                {
                    name: language == 'es' ? 'Dónde Comprar' : 'Where To Buy',
                    url: "/buy"
                },
                {
                    name: language == 'es' ? 'Políticas de Privacidad' : 'Privacy Policies',
                    url: "/privacy-policies"
                }
            ],
            images: [
                <StaticImage className={'first'} src={'../images/menu/left_5.webp'} alt={'Tequila'}/>,
                <StaticImage className={'second'} src={'../images/menu/right_5.webp'} alt={'Tequila'}/>
            ],
        }
    ]
    const [imagesMenu, setImagesMenu] = useState(menuItems[0].images)
    const menuLabels = {
        close: language == 'es' ? 'Cerrar' : 'Close',
        menu: language == 'es' ? 'Menú' : 'Menu'
    }
    const [menuVisible, setMenuVisible] = useState(false);

    return (
        <>
            <header id={"top"} className={
                `encabezado ${menuVisible ? 'menu-active' : ''}
                            ${offset > navOffset ? 'minify' : ''}`}>
                <div className="logostl">
                    <Link to={'/'}><StaticImage src="../images/slt-logo.svg" alt="logotipo santaleza"/></Link>
                </div>
                <div className="lang tmenu">
                    {languages.map((lng) => (
                        <a key={lng} className={lng === language ? 'active' : ''}
                           href="#"
                           onClick={(e) => {
                               e.preventDefault();
                               const lang = changeLanguage(lng);
                           }}>
                            {lng}
                        </a>
                    ))}
                </div>
                <div className="redesnav">
                    <a href="https://www.instagram.com/santalezatequila/" target="_blank" rel="noopener noreferrer">
                        <StaticImage src="../images/instagram-header.svg" alt="logo instagram"/>
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=100065685484883" target="_blank" rel="noopener noreferrer">
                        <StaticImage src="../images/facebook-header.svg" alt="logo facebook"/>
                    </a>
                    <a href="https://www.youtube.com/@kristykennedy1210/videos" target="_blank" rel="noopener noreferrer">
                        <StaticImage src="../images/youtube-header.svg" alt="logo Youtube"/>
                    </a>
                    {/* <a href="">
                        <StaticImage src="../images/twitter-header.svg" alt="logo twitter"/>
                    </a> */}
                </div>
                <button onClick={() => setMenuVisible(!menuVisible)} className="menu">
                    <p className="tmenu">{menuVisible ? menuLabels.close : menuLabels.menu}</p>
                    <Menu/>
                </button>
            </header>

            <section className={`nav-menu ${menuVisible ? 'active' : ''}`}>
                <div className="left">
                    <div className="first">
                        {
                            menuItems.map(menuItem => {
                                return (
                                    <div className={'item'}>
                                        <a href={menuItem.url} onMouseEnter={() => setImagesMenu(menuItem.images)}>
                                            <span>
                                                <svg width="33" height="23" viewBox="0 0 33 23" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M23.3735 22.7043H9.05322V3.5629L16.2362 19.1928L23.6423 4.15768V12.9077L32.7869 7.33742L23.3735 22.7043ZM16.4822 21.4747H22.4127V9.43056L16.4822 21.4747ZM10.2828 21.4747H15.9331L10.2828 9.17893V21.4747ZM23.6423 14.3489V19.9077L29.081 11.0319L23.6423 14.3489Z"
                                                        fill="#EF614B"/>
                                                    <path
                                                        d="M9.09315 22.71L0 7.37747L9.98531 13.4682L9.3505 14.5147L3.57435 10.9976L10.1454 22.0866L9.09315 22.71Z"
                                                        fill="#EF614B"/>
                                                    <path
                                                        d="M18.9754 13.9428L16.2818 4.47795L13.6682 13.6168L12.4844 13.2794L16.2875 0L20.1592 13.6054L18.9754 13.9428Z"
                                                        fill="#EF614B"/>
                                                </svg>
                                            </span>
                                            {menuItem.name}
                                        </a>
                                        {(menuItem.children !== null) ?
                                            <div className={'sub-items'}>
                                                {
                                                    menuItem.children.map((subMenu: { url: string | undefined; name: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; }) => {
                                                        return (
                                                            <div className="sub-item">
                                                                <a href={subMenu.url}>{subMenu.name}</a>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            :
                                            <></>
                                        }

                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="right">
                    <div className="content">
                        {imagesMenu}
                    </div>
                </div>
                <div className="bottom">
                    <div className="redes">
                        <a href="https://www.instagram.com/santalezatequila/" target="_blank" rel="noopener noreferrer">
                            <StaticImage src="../images/instagram-header.svg" alt="logo instagram"/>
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=100065685484883" target="_blank" rel="noopener noreferrer">
                            <StaticImage src="../images/facebook-header.svg" alt="logo facebook"/>
                        </a>
                        <a href="https://www.youtube.com/@kristykennedy1210/videos" target="_blank" rel="noopener noreferrer">
                            <StaticImage src="../images/youtube-header.svg" alt="logo Youtube"/>
                        </a>
                        {/* <a href="/">
                            <StaticImage src="../images/twitter-header.svg" alt="logo twitter"/>
                        </a> */}
                    </div>
                </div>
            </section>

            <main className={offset > navOffset ? 'nav-minify' : ''}>
                <ParallaxProvider>
                    {children}
                </ParallaxProvider>
            </main>
            {footer &&
                <footer>
                    {footerTop &&
                        <div className="top">
                            <StaticImage className="img img-1" src="../images/new_fondo.jpg" alt="fondo"/>
                            <StaticImage className="img img-2" src="../images/textura-ladrillos.png" alt="ladrillos"/>
                            <StaticImage className="img img-6" src="../images/textura-ladrillos-dos.png"
                                         alt="ladrillos_derecha"/>
                        </div>
                    }
                    <div className="bottom">
                        <div className="derechos tfooter">
                            <svg width="45" height="76" viewBox="0 0 45 76" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.5"
                                      d="M20.3872 0C9.06222 0 0.189495 9.0455 0.189495 20.5879L0 55.2651C0 60.7046 2.16245 65.7652 6.08607 69.5216C9.99854 73.2669 15.2709 75.329 20.9223 75.329L22.0536 75.3625L23.6922 75.329C35.0841 75.329 44.0404 66.3894 44.0794 54.9753V20.064C44.0794 8.81143 34.8834 0 23.1627 0H20.3872ZM0.835999 43.3828L3.43874 48.0978L3.39416 56.5692H0.819279C0.791413 56.1401 0.769121 55.7054 0.769121 55.2651L0.835999 43.3828ZM39.9161 56.5692H35.9256L39.9161 49.3518V56.5692ZM35.0451 56.5692H31.0211L40.401 46.8828L35.0451 56.5692ZM14.2454 56.5692L9.97068 40.5404L20.9 56.5692H14.2454ZM13.1976 55.6329L6.15852 48.3597L12.6124 53.437L13.1976 55.6329ZM21.4573 51.4529V56.0175L10.7175 40.2617L21.4573 51.4529ZM18.1913 46.9385C18.6261 45.7904 19.9302 41.7498 21.2567 37.6032C21.3235 37.397 21.3904 37.1852 21.4573 36.9734V37.6422V50.3383L18.1913 46.9385ZM31.7234 52.2332L35.385 36.4384L26.3785 45.9409L23.5027 37.9711C24.3276 38.0658 25.1245 38.1104 25.8937 38.1104C30.1238 38.1104 33.6016 36.823 37.3413 35.4408C38.1773 35.1342 39.03 34.8166 39.9106 34.51V45.7904L31.7234 52.2332ZM37.893 48.3597L30.9598 55.5215L31.4447 53.437L37.893 48.3597ZM25.7933 46.5707L22.2264 50.3327V37.7871V37.0292V36.6948L22.3546 37.0515L22.6444 37.854L25.7933 46.5707ZM32.7489 40.3509L22.232 56.0732V51.4585L32.7489 40.3509ZM33.6963 40.3119L29.9232 56.5692H22.8172L33.6963 40.3119ZM39.9161 33.6907C38.9408 34.0307 37.9989 34.3763 37.0793 34.7162C36.3715 34.9782 35.6748 35.2346 34.9838 35.4798C34.6103 35.6135 34.2369 35.7417 33.8691 35.8643C33.4176 36.0148 32.9606 36.1597 32.5092 36.2935C30.369 36.9344 28.2177 37.3636 25.8268 37.358C24.9908 37.358 24.1269 37.2967 23.224 37.1796L22.2264 34.4208V29.26C23.4303 29.1764 24.2941 28.7082 24.7957 27.8499C26.5959 24.7623 22.7336 17.6229 22.2264 16.7144V4.16327H23.0401C32.4981 4.16327 39.9106 11.1466 39.9106 20.064V33.6907H39.9161ZM24.1269 27.4709C23.7201 28.1732 22.9732 28.5131 21.8363 28.5131C20.7049 28.5131 19.9581 28.1732 19.5512 27.4709C18.1746 25.1023 20.8665 19.5011 21.8419 17.634C23.1516 20.1086 25.3865 25.3029 24.1269 27.4709ZM21.4573 16.72C20.9501 17.6284 17.0934 24.7679 18.888 27.8555C19.384 28.7138 20.2535 29.1819 21.4573 29.2655V34.432C21.2288 35.151 20.9836 35.9256 20.7272 36.7171C17.8012 36.0148 14.4628 34.6716 10.4556 32.4423C9.89265 32.1302 9.32975 31.8125 8.78356 31.506C7.15615 30.592 5.61791 29.7281 4.31375 29.0537L4.35834 20.6102C4.35834 11.3863 11.3974 4.16327 20.3872 4.16327H21.4573V16.72ZM10.0821 33.1167C14.1117 35.3627 17.5114 36.7171 20.4987 37.436C19.345 41.042 18.0854 44.9377 17.6006 46.331L8.05903 36.3938L12.278 52.2053L4.22458 45.8685L4.30818 29.9789C6.04706 30.8651 8.00887 31.9574 10.0821 33.1167ZM13.0304 56.5692H9.00649L3.65053 46.8828L13.0304 56.5692ZM4.20786 49.48L8.12591 56.5692H4.16885L4.20786 49.48ZM8.55505 57.3439L8.56063 57.3551H13.6546H13.95H20.2925L4.0741 65.9714C2.31293 63.4077 1.22056 60.465 0.886161 57.3439H8.55505ZM4.53112 66.6012L21.056 57.8232L11.3584 72.3139C9.63071 71.4389 8.03116 70.3131 6.62111 68.9643C5.85199 68.2286 5.15533 67.4372 4.53112 66.6012ZM20.9278 74.5544H20.9223C17.7845 74.5544 14.7749 73.8911 12.0607 72.6483L21.4517 58.6091V74.5711L20.939 74.5544H20.9278ZM23.6866 74.5599L22.2264 74.5878V58.5199L31.9463 72.782C29.4494 73.9246 26.6516 74.5599 23.6866 74.5599ZM32.6541 72.4476L22.7224 57.879L39.4034 66.8019C37.6311 69.1649 35.3237 71.0989 32.6541 72.4476ZM39.8548 66.1665L23.3801 57.3551H30.096H30.5362H35.4909L35.4965 57.3439H43.1542C42.7697 60.6155 41.6104 63.6139 39.8548 66.1665ZM43.3103 54.9697C43.3103 55.5103 43.2824 56.0398 43.2378 56.5692H40.6853V47.9585L43.3103 43.21V54.9697ZM23.1516 0.769119C34.4543 0.769119 43.3103 9.24057 43.3103 20.064V43.1152L40.6853 45.1829V20.064C40.6853 10.7175 32.9383 3.39415 23.0457 3.39415H20.3928C10.9739 3.39415 3.5948 10.9572 3.5948 20.6102L3.45546 45.2554L0.835999 43.1933L0.964187 20.5934C0.964187 9.48022 9.49694 0.774692 20.3984 0.774692H23.1516V0.769119Z"
                                      fill="white"/>
                            </svg>
                            <p><Trans>Rights reserved</Trans></p>
                        </div>

                        <div className="redes">
                            <a href="https://www.instagram.com/santalezatequila/" target="_blank" rel="noopener noreferrer">
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M6.36344 0.972312C7.43341 0.923055 7.77456 0.912109 10.5001 0.912109C13.2256 0.912109 13.5668 0.923967 14.6358 0.972312C15.7049 1.02066 16.4346 1.19123 17.0731 1.43843C17.7418 1.6911 18.3483 2.08606 18.85 2.59687C19.3608 3.09765 19.7549 3.70333 20.0067 4.37285C20.2548 5.01137 20.4244 5.7411 20.4737 6.80833C20.5229 7.88012 20.5339 8.22127 20.5339 10.9459C20.5339 13.6714 20.522 14.0126 20.4737 15.0826C20.4253 16.1498 20.2548 16.8795 20.0067 17.518C19.7549 18.1876 19.3602 18.7943 18.85 19.2958C18.3483 19.8066 17.7418 20.2007 17.0731 20.4525C16.4346 20.7006 15.7049 20.8702 14.6377 20.9195C13.5668 20.9687 13.2256 20.9797 10.5001 20.9797C7.77456 20.9797 7.43341 20.9678 6.36344 20.9195C5.29621 20.8711 4.56648 20.7006 3.92797 20.4525C3.25837 20.2007 2.65169 19.806 2.15016 19.2958C1.6397 18.7948 1.24467 18.1884 0.992626 17.5189C0.74543 16.8804 0.575768 16.1507 0.526511 15.0835C0.477255 14.0117 0.466309 13.6705 0.466309 10.9459C0.466309 8.22036 0.478167 7.87921 0.526511 6.81015C0.574856 5.7411 0.74543 5.01137 0.992626 4.37285C1.24504 3.7034 1.64037 3.09702 2.15107 2.59596C2.65189 2.08561 3.25796 1.69059 3.92705 1.43843C4.56557 1.19123 5.2953 1.02157 6.36253 0.972312H6.36344ZM14.5547 2.77839C13.4966 2.73005 13.1791 2.72002 10.5001 2.72002C7.82108 2.72002 7.50364 2.73005 6.44553 2.77839C5.46678 2.82309 4.93591 2.98637 4.58199 3.1241C4.11405 3.30654 3.77928 3.52272 3.4281 3.8739C3.0952 4.19777 2.83901 4.59203 2.6783 5.02779C2.54057 5.38171 2.37729 5.91258 2.33259 6.89134C2.28425 7.94944 2.27421 8.26688 2.27421 10.9459C2.27421 13.6249 2.28425 13.9424 2.33259 15.0005C2.37729 15.9792 2.54057 16.5101 2.6783 16.864C2.83884 17.2991 3.09516 17.6941 3.4281 18.0179C3.75192 18.3508 4.14688 18.6072 4.58199 18.7677C4.93591 18.9054 5.46678 19.0687 6.44553 19.1134C7.50364 19.1617 7.82016 19.1718 10.5001 19.1718C13.18 19.1718 13.4966 19.1617 14.5547 19.1134C15.5334 19.0687 16.0643 18.9054 16.4182 18.7677C16.8861 18.5853 17.2209 18.3691 17.5721 18.0179C17.905 17.6941 18.1614 17.2991 18.3219 16.864C18.4596 16.5101 18.6229 15.9792 18.6676 15.0005C18.7159 13.9424 18.726 13.6249 18.726 10.9459C18.726 8.26688 18.7159 7.94944 18.6676 6.89134C18.6229 5.91258 18.4596 5.38171 18.3219 5.02779C18.1395 4.55985 17.9233 4.22508 17.5721 3.8739C17.2482 3.54103 16.854 3.28484 16.4182 3.1241C16.0643 2.98637 15.5334 2.82309 14.5547 2.77839ZM9.21851 14.039C9.93425 14.337 10.7312 14.3772 11.4733 14.1528C12.2154 13.9284 12.8566 13.4534 13.2873 12.8088C13.718 12.1642 13.9116 11.39 13.835 10.6185C13.7584 9.84705 13.4163 9.12611 12.8672 8.57884C12.5171 8.229 12.0938 7.96113 11.6278 7.79451C11.1618 7.62789 10.6647 7.56666 10.1722 7.61524C9.67966 7.66382 9.20405 7.82099 8.77958 8.07544C8.35511 8.32989 7.99233 8.67529 7.71737 9.08677C7.4424 9.49826 7.26209 9.96559 7.18942 10.4551C7.11674 10.9447 7.15351 11.4442 7.29707 11.9178C7.44064 12.3914 7.68743 12.8273 8.01967 13.1941C8.35192 13.5609 8.76136 13.8495 9.21851 14.039ZM6.85327 7.29907C7.33218 6.82016 7.90073 6.44027 8.52645 6.18109C9.15217 5.92191 9.82282 5.78851 10.5001 5.78851C11.1774 5.78851 11.848 5.92191 12.4737 6.18109C13.0995 6.44027 13.668 6.82016 14.1469 7.29907C14.6258 7.77798 15.0057 8.34653 15.2649 8.97225C15.5241 9.59797 15.6575 10.2686 15.6575 10.9459C15.6575 11.6232 15.5241 12.2938 15.2649 12.9195C15.0057 13.5453 14.6258 14.1138 14.1469 14.5927C13.1797 15.5599 11.8679 16.1033 10.5001 16.1033C9.13227 16.1033 7.82047 15.5599 6.85327 14.5927C5.88607 13.6255 5.34271 12.3137 5.34271 10.9459C5.34271 9.57807 5.88607 8.26627 6.85327 7.29907ZM16.8013 6.55657C16.92 6.44462 17.015 6.31 17.0807 6.16067C17.1464 6.01134 17.1815 5.85035 17.1839 5.68722C17.1863 5.52409 17.1559 5.36214 17.0946 5.21096C17.0332 5.05978 16.9422 4.92244 16.8268 4.80708C16.7115 4.69172 16.5741 4.60067 16.4229 4.53934C16.2718 4.47801 16.1098 4.44763 15.9467 4.45001C15.7836 4.45239 15.6226 4.48747 15.4732 4.55319C15.3239 4.6189 15.1893 4.71391 15.0773 4.83258C14.8596 5.06339 14.7404 5.36996 14.745 5.68722C14.7497 6.00447 14.8777 6.30744 15.1021 6.5318C15.3265 6.75616 15.6294 6.88425 15.9467 6.88887C16.2639 6.8935 16.5705 6.7743 16.8013 6.55657Z"
                                          fill="white"/>
                                </svg>
                            </a>

                            <a href="https://www.facebook.com/profile.php?id=100065685484883" target="_blank" rel="noopener noreferrer">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M0 11.0071C0 16.449 3.9524 20.9743 9.12163 21.8919V13.9862H6.38514V10.946H9.12163V8.51321C9.12163 5.77673 10.8848 4.25706 13.3787 4.25706C14.1686 4.25706 15.0206 4.37838 15.8105 4.4997V7.2973H14.4122C13.074 7.2973 12.7703 7.96592 12.7703 8.81787V10.946H15.6892L15.203 13.9862H12.7703V21.8919C17.9395 20.9743 21.8919 16.4499 21.8919 11.0071C21.8919 4.95304 16.9662 0 10.946 0C4.92568 0 0 4.95304 0 11.0071Z"
                                          fill="white"/>
                                </svg>
                            </a>
                            <a href="https://www.youtube.com/@kristykennedy1210/videos" target="_blank" rel="noopener noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="21px" viewBox="0 0 23 21" fill="none">
                                    <g id="surface1">
                                        <path fill="white" d="M 21.949219 5.089844 C 21.695312 4.121094 20.957031 3.355469 20.019531 3.097656 C 18.320312 2.625 11.5 2.625 11.5 2.625 C 11.5 2.625 4.679688 2.625 2.980469 3.097656 C 2.042969 3.355469 1.304688 4.121094 1.050781 5.089844 C 0.597656 6.847656 0.597656 10.515625 0.597656 10.515625 C 0.597656 10.515625 0.597656 14.183594 1.050781 15.941406 C 1.304688 16.914062 2.042969 17.644531 2.980469 17.902344 C 4.679688 18.375 11.5 18.375 11.5 18.375 C 11.5 18.375 18.320312 18.375 20.019531 17.902344 C 20.957031 17.644531 21.695312 16.914062 21.949219 15.941406 C 22.402344 14.183594 22.402344 10.515625 22.402344 10.515625 C 22.402344 10.515625 22.402344 6.847656 21.949219 5.089844 Z M 9.269531 13.847656 L 9.269531 7.183594 L 14.96875 10.515625 Z M 9.269531 13.847656 "/>
                                    </g>
                                </svg>
                            </a>

                            {/* <a href="/">
                                <svg width="22" height="18" viewBox="0 0 22 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M21.6745 2.50306C20.9128 2.84056 20.0946 3.0686 19.2344 3.17167C20.122 2.6406 20.786 1.80476 21.1025 0.820116C20.2687 1.31541 19.3561 1.66404 18.4044 1.85086C17.7644 1.16753 16.9167 0.714603 15.9929 0.562407C15.0691 0.41021 14.1209 0.567257 13.2955 1.00916C12.4702 1.45107 11.8138 2.15312 11.4283 3.0063C11.0428 3.85948 10.9497 4.81607 11.1636 5.72755C9.47399 5.64272 7.8211 5.20356 6.3122 4.43858C4.8033 3.6736 3.47211 2.59989 2.40502 1.28714C2.04015 1.91654 1.83036 2.64627 1.83036 3.42343C1.82995 4.12305 2.00224 4.81196 2.33194 5.42903C2.66163 6.0461 3.13855 6.57225 3.72036 6.96079C3.04561 6.93932 2.38575 6.757 1.7957 6.429V6.48373C1.79563 7.46498 2.13505 8.41604 2.75637 9.17552C3.37769 9.935 4.24264 10.4561 5.20445 10.6505C4.57851 10.8199 3.92225 10.8448 3.28526 10.7235C3.55662 11.5678 4.08522 12.3061 4.79704 12.8351C5.50887 13.364 6.36829 13.6571 7.25499 13.6734C5.74977 14.855 3.89083 15.496 1.97722 15.4932C1.63824 15.4933 1.29955 15.4735 0.962891 15.4339C2.90532 16.6828 5.16645 17.3456 7.47573 17.343C15.293 17.343 19.5664 10.8685 19.5664 5.25323C19.5664 5.07079 19.5619 4.88654 19.5537 4.7041C20.3849 4.10297 21.1024 3.35857 21.6726 2.50579L21.6745 2.50306Z"
                                        fill="white"/>
                                </svg>
                            </a> */}
                        </div>

                        <div className="politicas tfooter">
                            <Link to="/privacy-policies" className="linkFormat">Política de privacidad</Link>
                        </div>
                        <StaticImage className="img-1" src="../images/maguey.png" alt="maguey"/>
                    </div>
                </footer>
            }
        </>
    )
}


export default Layout